module.exports = __webpack_public_path__ + "img/mp-boards-create.850096bf.jpg";